// what we send to the patch request when we change notification settings
export interface NotificationPayload {
  email: NotificationValue
  // this is a boolean because either sound is on or off
  sound: NotificationSound
  ABM: boolean
}

export enum NotificationPlatform {
  EMAIL_NOTIFICATION = 'humane-notifications-email',
  SOUND_SETTING = 'humane-notifications-browser-sound',
  ABM = 'follow_accounts'
}

export enum NotificationValue {
  // humane notification expect a value of the following: all, mine, mine-and-unassigned, nothing
  // however, the only two options we support in the desktop app right now are on and off
  MINE = 'mine',
  MINE_AND_UNASSIGNED = 'mine-and-unassigned',
  ALL = 'all',
  OFF = 'nothing'
}

export enum NotificationSound {
  DING = 'ding',
  CLICK = 'click',
  GLOSSY = 'glossy',
  POP = 'pop',
  XYLOPHONE = 'xylophone',
  NONE = 'none'
}
